module.exports = __webpack_public_path__ + "static/socialproof-urgency-7fa304ead2f44177a0d69c83e4a7a55a.png";